import { ReferralFormValidationSchema } from '@/modules/Sites';

export const referralFormValidationSchema: ReferralFormValidationSchema = {
  name: [
    { required: true, message: 'Введіть назву реєстратора домену' },
    { type: 'string', message: 'Хостинг має бути строкою' },
    { min: 1, max: 255, message: 'Хостинг має бути довжиною не менше 1 символа та не більше 255' }
  ],
  slug: [
    { required: true, message: 'Введіть слаг ноди' },
    { type: 'string', message: 'Слаг має бути строкою' },
    { min: 1, max: 255, message: 'Слаг має бути довжиною не менше 1 символа та не більше 255' },
    {
      required: true,
      message: 'Слаг не може містити символи: ? : / . # [ ] @ space tab newline',
      validator: (_, value) => {
        if (value) {
          const match = value.match(/[\t\n\v\f\r #./:?@[\]]/gim);

          if (value === '/' || !match) {
            return Promise.resolve();
          }
        }
        return Promise.reject();
      }
    }
  ],
  siteId: []
};
